export default {
  methods: {
    snipcart () {
      return window.Snipcart
    }
  }
}